var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { blueToolbarIconColors, hoveredPlaceholderIconColors, svgDataUrl, } from "ui/components/elements/icons/vacuum-pump";
/** A grip position with no cup picked yet: the cup alone, lying on its
 * marker in the scene, a little darker than the other placeholders' symbols
 * since the marker is the grip position's own (resizable) surface. */
export var gripPositionPlaceholderIconColors = {
    disc: "none",
    ring: "none",
    symbol: "#D9D9D9",
};
/** The grip position placeholder while hovered: the other placeholders' hover
 * disc and ring under the cup, which keeps its own colour as their symbols
 * do. */
export var hoveredGripPositionPlaceholderIconColors = __assign(__assign({}, hoveredPlaceholderIconColors), { symbol: gripPositionPlaceholderIconColors.symbol });
export var CentralizedGripPositionIcon = function (_a) {
    var size = _a.size, _b = _a.colors, colors = _b === void 0 ? blueToolbarIconColors : _b;
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 43 43", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "21.0827", cy: "21.0827", r: "19.899", fill: colors.disc, fillOpacity: "0.65", stroke: colors.ring, strokeWidth: "2.36733" }), _jsx("path", { d: "M26.0263 20.0776L32.5225 27.4938L9.78605 27.4938L16.2822 20.0776M26.0263 20.0776L26.0263 14.1445L16.2822 14.1445L16.2822 20.0776M26.0263 20.0776L16.2822 20.0776", stroke: colors.symbol, strokeWidth: "1.57822", strokeLinecap: "round", strokeLinejoin: "round" })] }));
};
/**
 * The icon as an SVG data URL, for drawing it as a PlayCanvas texture (see
 * `vacuumPumpIconDataUrl`).
 */
export var gripPositionIconDataUrl = function (size, colors) {
    return svgDataUrl(_jsx(CentralizedGripPositionIcon, { size: size, colors: colors }));
};
